import { FormValidations } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const nameFormValidations = (): FormValidations => {
  return {
    DESC_TMJMENO: {
      required: true,
      type: "Pattern",
      regex: /^[[a-zA-Z\u00C0-\u024F ]{1,50}$/,
      message: "nameFormValidation.DESC_TMJMENO"
    } as PatternValidatonRule,
    DESC_TMPRIJMENI: {
      required: true,
      type: "Pattern",
      regex: /^[[a-zA-Z\u00C0-\u024F ]{1,50}$/,
      message: "nameFormValidation.DESC_TMPRIJMENI"
    } as PatternValidatonRule
  };
}